module.exports = __webpack_public_path__ + "img/zhuti-03.38ecec11.png";